import { Observable } from "rxjs";
import { map, mapTo } from "rxjs/operators";
import { inject, injectable } from "tsyringe";
import { NotificationsRepository } from "src/containers/configuration/repositories/notifications/notifications-repository";
import { autoBind } from "src/shared/decorators/autobind";
import { GenericSuccessResponse } from "src/infra/http/types";
import { PushSubscription } from "src/containers/configuration/models/push-subcription";
import { PushSubscriptionRequest } from "src/containers/configuration/models/push-subscription-request";

@injectable()
export class NotificationsService {
    constructor(
        @inject("NotificationsRepository")
        private repository: NotificationsRepository
    ) {}

    @autoBind
    getSubscription(
        userIdentity: string
    ): Observable<PushSubscription | undefined> {
        return this.repository.getSubscription(userIdentity).pipe(
            map((data) => {
                return PushSubscription.fromJson<PushSubscription>(data[0]);
            })
        );
    }

    @autoBind
    createSubscription(
        request: PushSubscriptionRequest,
        userIdentity: string
    ): Observable<PushSubscriptionRequest> {
        return this.repository.createSubscription(request, userIdentity).pipe(
            map(() => {
                return PushSubscription.fromJson({
                    ...request.toJson(),
                    enabled: true,
                });
            })
        );
    }

    @autoBind
    updateSubscription(
        subscription: PushSubscriptionRequest,
        subscriptionId: number,
        userIdentity: string
    ): Observable<GenericSuccessResponse> {
        return this.repository
            .updateSubscription(subscription, subscriptionId, userIdentity)
            .pipe(mapTo({ status: "ok", code: 200 }));
    }
}
